import React, { useState, useEffect } from "react";
import { purple } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import ReactSelect from "react-select";
import { FormControl, InputLabel } from "@material-ui/core";
import PropTypes from "prop-types";
import { FixedSizeList } from "react-window";
import { removerCaracteresControle } from "../../utils/formatacoes";

const menuListVirtualizado = (props) => {
  let alturaDinamica;
  const alturaItem = 36;
  const elementosExtrasVirtualizados = 3;

  let ehLista = Array.isArray(props.children);
  let quantidadeLimiteItens = props.maxHeight / alturaItem;

  if (ehLista && props.children.length < quantidadeLimiteItens) {
    alturaDinamica = props.children.length * alturaItem;
  }

  if (ehLista) {
    return (
      <FixedSizeList
        height={alturaDinamica || props.maxHeight}
        itemCount={props.children.length}
        itemSize={alturaItem}
        overscanCount={elementosExtrasVirtualizados}
      >
        {({ index, style }) => {
          return (<div style={style}>{props.children[index]}</div>)
        }}
      </FixedSizeList>
    );
  } else {
    return (props.children);
  }
}

const Selecao = props => {
  const {
    proriedadesPersonalizadas,
    retornarObjetoCompleto,
    habilitarModoPerformance,
    mensagemSemOpcoes,
    abrirMenuAoFocar,
    handleLimpar,
    desativarCampo,
    campoRequerido,
    getOptionValue,
    getOptionLabel,
    maxHeightMenu,
    handleChange,
    isClearable,
    components,
    autoFocus,
    etiqueta,
    onBlur,
    opcoes,
    codigo,
    id
  } = props;

  const classes = useStyles();
  const valor = codigo ? opcoes.find(o => o.codigo === codigo) : null;
  const etiquetaTratada = campoRequerido ? etiqueta + "*" : etiqueta;

  const [campoSelecionado, setCampoSelecionado] = useState(null);
  const [erroCamportamento, setErroCamportamento] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setErroCamportamento(
      !campoSelecionado && campoSelecionado !== null && !valor && campoRequerido
    );
  }, [campoSelecionado, valor, campoRequerido]);

  const handleSelectOption = option => {
    if (option) {
      handleChange(retornarObjetoCompleto ? option : option.codigo);
    } else if (handleLimpar) {
      handleLimpar();
    }
  };

  if (habilitarModoPerformance) {
    components.MenuList = menuListVirtualizado;
  }

  const handleChangeInput = (value) => {
    value = removerCaracteresControle(value);

    setInputValue(value);

    if (proriedadesPersonalizadas && proriedadesPersonalizadas.onInputChange) {
      proriedadesPersonalizadas.onInputChange(value);
    }
  }

  return (
    <FormControl
      id="form"
      variant="outlined"
      className={classes.input}
      onClick={() => setCampoSelecionado(true)}
    >
      {codigo && (
        <InputLabel
          style={{
            color:
              erroCamportamento && !desativarCampo
                ? "#f44336"
                : campoSelecionado && !desativarCampo
                  ? purple["A200"]
                  : "rgba(0, 0, 0, 0.54)",
            backgroundImage: desativarCampo
              ? "linear-gradient(180deg, transparent 50%, hsl(0,0%,95%) 50%)"
              : "none"
          }}
          className={classes.labelFlutuante}
          htmlFor="outlined-age-native-simple"
        >
          {etiquetaTratada}
        </InputLabel>
      )}
      <ReactSelect
        noOptionsMessage={() => mensagemSemOpcoes}
        onBlur={onBlur ? null : () => setCampoSelecionado(false)}
        styles={estilos(erroCamportamento, maxHeightMenu)}
        getOptionValue={getOptionValue}
        getOptionLabel={getOptionLabel}
        {...proriedadesPersonalizadas}
        onChange={handleSelectOption}
        placeholder={etiquetaTratada}
        filterOption={props.filterOption}
        isDisabled={desativarCampo}
        isClearable={isClearable}
        className={classes.input}
        autoFocus={autoFocus}
        options={opcoes}
        components={components}
        openMenuOnFocus={abrirMenuAoFocar}
        tabSelectsValue
        onInputChange={handleChangeInput}
        inputValue={inputValue}
        value={valor}
        id={id}
      />
    </FormControl>
  );
};

const estilos = (erroCamportamento, maxHeight) => ({
  menuList: styles => ({ ...styles, maxHeight: maxHeight }),
  menu: styles => ({ ...styles, zIndex: 2 }),
  input: provided => ({
    ...provided,
    paddingTop: "12px",
    paddingBottom: "12px",
    width: "100%",
    fontFamily: "CircularStd-Book",
    fontSize: "16px"
  }),
  singleValue: provided => ({
    ...provided,
    fontSize: "16px"
  }),
  placeholder: provided => ({
    ...provided,
    fontFamily: "CircularStd-Book",
    fontSize: "1rem",
    color: erroCamportamento ? "#f44336" : "rgba(0, 0, 0, 0.54)"
  }),
  control: (styles, { isFocused }) => ({
    ...styles,
    ":hover": {
      borderColor: erroCamportamento ? "#f44336" : isFocused ? purple["A200"] : "black"
    },
    boxShadow: isFocused ? `0 0 0 1px ${purple["A200"]}` : "none",
    borderColor: erroCamportamento ? "#f44336" : isFocused ? purple["A200"] : "hsl(0, 0%, 70%)"
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled ? null : isSelected || isFocused ? "hsl(0,0%,95%)" : null,
      cursor: "pointer",
      color: "rgba(0,0,0,0.54)",
      ":active": {
        ...styles[":active"],
        backgroundColor: "transparent"
      }
    };
  }
});

const useStyles = makeStyles({
  input: {
    width: "100%",
    maxHeight: "100px"
  },
  disabled: {
    backgroundColor: "rgb(242, 242, 242)",
    borderColor: "rgb(230, 230, 230)"
  },
  labelFlutuante: {
    backgroundColor: "white",
    transform: "scale(0.75)",
    padding: "0 8px 0 8px",
    position: "absolute",
    fontSize: "1rem",
    lineHeight: "1",
    height: "16px",
    top: "-6px",
    left: "6px"
  }
});

Selecao.propTypes = {
  codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  proriedadesPersonalizadas: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  retornarObjetoCompleto: PropTypes.bool,
  mensagemSemOpcoes: PropTypes.string,
  maxHeightMenu: PropTypes.string,
  campoRequerido: PropTypes.bool,
  desativarCampo: PropTypes.bool,
  isClearable: PropTypes.bool,
  etiqueta: PropTypes.string,
  autoFocus: PropTypes.bool,
  opcoes: PropTypes.array,
  id: PropTypes.string,
  abrirMenuAoFocar: PropTypes.bool,
  filterOption: PropTypes.func
};

Selecao.defaultProps = {
  mensagemSemOpcoes: "Sem opções",
  retornarObjetoCompleto: false,
  proriedadesPersonalizadas: {},
  campoRequerido: false,
  maxHeightMenu: "300px",
  desativarCampo: false,
  isClearable: false,
  autoFocus: false,
  etiqueta: "",
  codigo: null,
  opcoes: [],
  id: "",
  abrirMenuAoFocar: true,
  getOptionValue: option => option.codigo,
  getOptionLabel: option => option.descricao,
  filterOption: (option, text) =>
    option.label.toString().toUpperCase().startsWith(text.toUpperCase())
};

export default Selecao;
